'use client';

import { FC, useEffect } from 'react';

import { filterSidebarStore } from '@/stores/filterSidebarStore';

interface ScrollObserverHandlerProps {
  children: React.ReactNode;
  scrollBoxRef: React.RefObject<HTMLDivElement | null>;
}

export const ScrollObserverHandler: FC<ScrollObserverHandlerProps> = ({ children, scrollBoxRef }) => {
  const { scrollPosition, setScrollPosition } = filterSidebarStore((state) => ({
    setScrollPosition: state.setScrollPosition,
    scrollPosition: state.scrollPosition,
  }));

  useEffect(() => {
    const handleScroll = () => {
      if (scrollBoxRef.current) {
        setScrollPosition(scrollBoxRef.current.scrollTop);
      }
    };

    if (typeof window !== 'undefined' && scrollBoxRef.current) {
      if (scrollPosition && scrollBoxRef.current) {
        scrollBoxRef.current.scrollTop = scrollPosition;
      }

      scrollBoxRef.current.addEventListener('scroll', handleScroll);

      return () => {
        scrollBoxRef.current?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [scrollBoxRef, setScrollPosition]);

  return <>{children}</>;
};
